<template>
  <router-link
    v-if="routerName"
    :to="{ name: routerName }"
    class="btn-close"
    :class="[variant, size]"
    @click="clickHandler"
  >
    <span class="cross"><slot></slot></span>
  </router-link>
  <a
    v-else-if="href"
    :href="href"
    class="btn-close"
    :class="[variant, size]"
    @click="clickHandler"
  >
    <span class="cross"><slot></slot></span>
  </a>
  <button
    v-else
    class="text btn-close"
    :class="[variant, size]"
    @click="clickHandler"
  >
    <span class="cross"><slot></slot></span>
  </button>
</template>

<script>
export default {
  name: "BtnClose",
  props: {
    variant: { type: String, default: "" },
    size: { type: String, default: "" },
    routerName: { type: String, default: "" },
    href: { type: String, default: "" },
  },
  emits: ["click"],
  methods: {
    clickHandler: function (e) {
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btn-close {
  display: inline-block;
  width: 380px;
  max-width: 100%;
  text-align: center;
  padding: 17px 0px;
  border-radius: 27px;
  font-size: 14px;
  line-height: 14px;
  @include mq-up(md) {
    border-radius: 30px;
    font-size: 20px;
    line-height: 24px;
  }
  &.-close {
    background-color: $white;
    color: $black;
    border: 1px solid $secondary;
  }
  &.-md {
    background-color: $white;
    color: $black;
    border: 1px solid $secondary;
  }
  &.-sm {
    width: 240px;
    font-size: 14px;
    padding: 13px 0px;
    @include mq-up(md) {
      width: 160px;
      font-size: 16px;
      line-height: 16px;
    }
  }
  > .cross {
    background-image: url("@/assets/images/icons/close.svg");
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 12px auto;
    padding-left: 25px;
    &:hover {
      background-image: url("@/assets/images/icons/close.svg");
    }
  }
}
</style>
